import clsx from 'clsx';
import React from 'react';
import './UiCard.css';
import { UiText } from '../text/UiText';
import { UiCardFooter } from './footer/UiCardFooter';
import { UiGrid } from '../grid/UiGrid';
export function UiCard(_a) {
    var isTransparent = _a.isTransparent, isOverflowHidden = _a.isOverflowHidden, header = _a.header, content = _a.content, _b = _a.contentPadding, contentPadding = _b === void 0 ? 0 : _b, _c = _a.footerPadding, footerPadding = _c === void 0 ? 2 : _c, footer = _a.footer, isGrid = _a.isGrid, className = _a.className, onClick = _a.onClick, fullHeight = _a.fullHeight, children = _a.children;
    var classes = clsx('UiCard', isTransparent && 'transparent', isOverflowHidden && 'overflow-hidden', className, onClick && 'clickable');
    var Element = onClick ? 'a' : 'div';
    if (content) {
        children = content;
    }
    return (React.createElement("div", { className: classes },
        header && (React.createElement(React.Fragment, null, header.length ? (React.createElement("div", null,
            React.createElement(UiText, { weight: 2 }, header))) : (header))),
        React.createElement(Element, { onClick: onClick, className: clsx('content', "padding-" + contentPadding, fullHeight && "full-height") }, isGrid ? React.createElement(UiGrid, null, children) : children),
        footer && (React.createElement(UiCardFooter, { padding: footerPadding, justifyContent: "flex-end" }, footer))));
}
